/* HHD Product Options - original code for Hippie Hill Designs.
   Dependent dropdowns (Size -> Packaging -> Quantity -> Finish/Color), live price,
   line-item properties, and add-on fee lines linked to the design line in the cart. */
(function(){
  'use strict';
  function money(n){return '$'+Number(n).toFixed(2);}
  function el(tag,attrs,kids){var e=document.createElement(tag);for(var k in attrs||{})e.setAttribute(k,attrs[k]);(kids||[]).forEach(function(c){e.appendChild(typeof c==='string'?document.createTextNode(c):c);});return e;}
  function uid(){return 'h'+Date.now().toString(36)+Math.random().toString(36).slice(2,6);}

  function init(root){
    var cfg; try{cfg=JSON.parse(root.querySelector('[data-hhd-config]').textContent);}catch(e){console.warn('HHD options: bad config',e);return;}
    var base=Number(root.getAttribute('data-base'))/100, title=root.getAttribute('data-title');
    var section=root.closest('section')||document;
    var form=section.querySelector('form[data-type="add-to-cart-form"]')||document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
    if(!form) return;
    // "Buy it now" would skip the add-on lines, so hide it while our options are active.
    section.querySelectorAll('.shopify-payment-button').forEach(function(b){b.style.display='none';});
    var sizes=(cfg.sizes||[]).map(function(s){
      var pk={};Object.keys(s.packaging||{}).forEach(function(p){
        var q=(s.packaging[p]||[]).filter(function(x){return x.variant;});  // hide options with no add-on product yet
        if(q.length) pk[p]=q;});
      return {name:s.name,colors:s.colors||[],packaging:pk};
    }).filter(function(s){return Object.keys(s.packaging).length;});
    if(!sizes.length) return;
    var fields=root.querySelector('.hhd-opts__fields'), state={};
    var defs=[['size','Size'],['packaging','Packaging'],['qty','Quantity'],['finish','Finish'],['color','Bag Color']];
    var sel={};
    defs.forEach(function(d){
      var s=el('select',{id:'hhd-'+d[0],'data-k':d[0]});
      var w=el('div',{'class':'hhd-opts__field'},[el('label',{'for':'hhd-'+d[0]},[d[1]]),s]);
      fields.appendChild(w); sel[d[0]]={s:s,w:w};
      s.addEventListener('change',function(){state[d[0]]=s.value;render();});
    });
    function fill(k,opts){ // opts: [{v,label}] ; hides the field when empty
      var s=sel[k].s, cur=state[k];
      s.innerHTML=''; opts.forEach(function(o){s.appendChild(el('option',{value:o.v},[o.label]));});
      if(!opts.some(function(o){return o.v===cur;})) cur=opts.length?opts[0].v:'';
      s.value=cur; state[k]=cur; sel[k].w.style.display=opts.length>1||k==='size'||k==='qty'?'':'none';
      if(!opts.length) sel[k].w.style.display='none';
    }
    function current(){
      var size=sizes.filter(function(s){return s.name===state.size;})[0];
      var list=size&&size.packaging[state.packaging]||[];
      var q=list.filter(function(x){return x.qty===state.qty;})[0];
      return {size:size,q:q,holo:state.finish==='Holographic'&&q&&q.holo};
    }
    function render(){
      fill('size',sizes.map(function(s){return {v:s.name,label:s.name};}));
      var size=current().size;
      fill('packaging',Object.keys(size.packaging).map(function(p){return {v:p,label:p};}));
      fill('qty',size.packaging[state.packaging].map(function(x){return {v:x.qty,label:x.qty+' (+'+money(x.price)+')'};}));
      var q=current().q, fin=[{v:'Premium Glossy',label:'Premium Glossy'}];
      if(q&&q.holo&&q.holo.variant) fin.push({v:'Holographic',label:'Holographic (+'+money(q.holo.price)+')'});
      fill('finish',fin);
      fill('color',state.packaging==='Complete Packaging'?size.colors.map(function(c){return {v:c,label:c};}):[]);
      var c=current(), total=base+(c.q?c.q.price:0)+(c.holo?c.holo.price:0);
      root.querySelector('[data-hhd-total]').textContent=money(total);
      root.querySelector('[data-hhd-break]').textContent=cfg.base_label+' '+money(base)+' + '+state.qty+' '+money(c.q?c.q.price:0)+(c.holo?' + Holographic '+money(c.holo.price):'');
    }
    render();

    // Intercept add to cart (capture phase runs before Dawn's product-form handler).
    // While Globo is still installed (preview only), hide its widget so customers see one set of options.
    form.querySelectorAll('.gpo-app,.gpo-container,gpo-container,gpo-hidden-inputs').forEach(function(x){x.style.display='none';});
    function onAdd(ev){
      ev.preventDefault(); ev.stopImmediatePropagation();
      var c=current(); if(!c.q) return;
      var btn=root.querySelector('[data-hhd-add]'); if(btn){btn.setAttribute('disabled','disabled');btn.classList.add('loading');}
      var n=Math.max(1,parseInt((section.querySelector('input[name="quantity"]')||{}).value,10)||1);
      var g=uid(), props={'Size':state.size,'Packaging':state.packaging,'Quantity':state.qty,'Finish':state.finish,'_hhd_group':g};
      if(state.color) props['Bag Color']=state.color;
      var fd=new FormData(form), items=[{id:Number(fd.get('id')),quantity:n,properties:props}];
      items.push({id:c.q.variant,quantity:n,properties:{'For':title,'_hhd_parent':g}});
      if(c.holo) items.push({id:c.holo.variant,quantity:n,properties:{'For':title,'_hhd_parent':g}});
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
        .then(function(){window.location.href=(window.routes&&routes.cart_url)||'/cart';})
        .catch(function(e){alert((e&&(e.description||e.message))||'Could not add to cart.');if(btn){btn.removeAttribute('disabled');btn.classList.remove('loading');}});
    }
    form.addEventListener('submit',onAdd,true);
    // Our own Add to cart button (the theme button is hidden by CSS while this block is active).
    var add=root.querySelector('[data-hhd-add]'); add.addEventListener('click',onAdd);
  }
  function boot(){document.querySelectorAll('[data-hhd-opts]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
